import { render, staticRenderFns } from "./Busca.vue?vue&type=template&id=06f6d5f5"
import script from "./Busca.vue?vue&type=script&setup=true&lang=ts"
export * from "./Busca.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Busca.vue?vue&type=style&index=0&id=06f6d5f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports